import type { DividerProps } from 'antd'
import { Divider } from "antd"

import { theme } from 'antd'

interface CDividerProps extends DividerProps {
  typeOf: 'primary' | 'secondary'
  title: string
}

export default function CDivider(props: CDividerProps) {

  const { token } = theme.useToken()
  if (props.typeOf === 'primary') {
    return (
      <Divider style={{ borderColor: token.colorPrimary }}>
        <strong>{props.title}</strong>
      </Divider>
    );
  }

  return (
    <Divider variant="dotted" style={{ borderColor: token.colorPrimary }}>
      {props.title}
    </Divider>
  );

}